var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error)?_c('span',{staticClass:"error__message"},[_vm._v(" "+_vm._s(_vm.error[0])+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }